import React from 'react'
import { useAccordion } from './Accordion'
import { IAccordionItemProps } from './types'

const AccordionItem: React.FC<IAccordionItemProps> = ({
  id,
  title,
  description,
  stepNumber,
  isExpanded,
  isCompleted = false,
  isDisabled = false,
  onToggle,
  children,
  className = '',
}) => {
  const { expandedItems, toggleItem } = useAccordion()
  const isItemExpanded = expandedItems.includes(id)

  const handleToggle = () => {
    if (!isDisabled) {
      toggleItem(id)
      onToggle(id)
    }
  }

  return (
    <div className={`accordion-item ${className}`}>
      <div
        className={`accordion-header ${isItemExpanded ? 'expanded' : ''} ${
          isDisabled ? 'disabled' : ''
        }`}
        onClick={handleToggle}
        role="button"
        tabIndex={isDisabled ? -1 : 0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            handleToggle()
          }
        }}
      >
        <div className="accordion-header-left">
          <div className={`step-number ${isCompleted ? 'completed' : ''}`}>{stepNumber}</div>
          <div className="step-info">
            <h3 className="step-title">{title}</h3>
            {description && <p className="step-description">{description}</p>}
          </div>
        </div>
        <div className="accordion-header-right">
          <div className={`chevron ${isItemExpanded ? 'expanded' : ''}`}>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4 6L8 10L12 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <div className={`accordion-content ${isItemExpanded ? 'expanded' : ''}`}>
        <div className="accordion-content-inner">{children}</div>
      </div>
    </div>
  )
}

export default AccordionItem
